import React from "react";
import GeneralBaseModal from "../../Modals/GeneralBaseModal";
import { NewUserShadow } from "../../NewUserShadow";
import { StyledContainer } from "./styles";

const ShadowOfferModal = ({ isOpen, onClose, onButtonClick }) => {
  return (
    <GeneralBaseModal
      isOpen={isOpen}
      onClose={onClose}
    >
      <StyledContainer>
        <NewUserShadow onButtonClick={onButtonClick} />
      </StyledContainer>
    </GeneralBaseModal>
  );
};

export default ShadowOfferModal;
